// Shared storefront cart integration for cross-domain persistence
(function () {
  'use strict';

  var CART_COOKIE_NAME = 'kc_cart_id';
  var CART_COOKIE_MAX_AGE = 2592000; // 30 days in seconds
  var STOREFRONT_ENDPOINT = 'https://keycard.tech/api/shopify/storefront';

  function getCookie(name) {
    if (typeof document === 'undefined') return null;
    var value = document.cookie || '';
    var parts = value.split(/;\s*/);
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (!part) continue;
      var eqIndex = part.indexOf('=');
      if (eqIndex === -1) continue;
      var key = part.slice(0, eqIndex).trim();
      if (key === name) {
        return decodeURIComponent(part.slice(eqIndex + 1));
      }
    }
    return null;
  }

  function setCookie(name, value, options) {
    if (options === void 0) options = {};
    if (typeof document === 'undefined') return;
    var cookie = name + '=' + encodeURIComponent(value);
    cookie += '; Domain=.keycard.tech';
    cookie += '; Path=/';
    var maxAge = typeof options.maxAge === 'number' ? options.maxAge : CART_COOKIE_MAX_AGE;
    cookie += '; Max-Age=' + String(maxAge);
    cookie += '; Secure';
    cookie += '; SameSite=Lax';
    document.cookie = cookie;
  }

  function deleteCookie(name) {
    if (typeof document === 'undefined') return;
    document.cookie = name + '=; Domain=.keycard.tech; Path=/; Max-Age=0; Secure; SameSite=Lax';
  }

  function storefrontRequest(query, variables) {
    if (variables === void 0) variables = {};
    return fetch(STOREFRONT_ENDPOINT, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ query: query, variables: variables }),
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error('Storefront request failed with status ' + response.status);
        error.status = response.status;
        throw error;
      }
      return response.json();
    }).then(function (payload) {
      if (payload == null) return payload;
      if (payload.errors && payload.errors.length) {
        var error = new Error('Storefront GraphQL error');
        error.graphQLErrors = payload.errors;
        throw error;
      }
      return payload.data;
    });
  }

  var CART_FRAGMENT = [
    'fragment SharedCartFragment on Cart {',
    '  id',
    '  checkoutUrl',
    '  totalQuantity',
    '  cost {',
    '    subtotalAmount { amount currencyCode }',
    '    totalAmount { amount currencyCode }',
    '  }',
    '  discountCodes { code applicable }',
    '  lines(first: 50) {',
    '    edges {',
    '      node {',
    '        id',
    '        quantity',
    '        cost {',
    '          totalAmount { amount currencyCode }',
    '        }',
    '        merchandise {',
    '          __typename',
    '          ... on ProductVariant {',
    '            id',
    '            title',
    '            product {',
    '              title',
    '              handle',
    '            }',
    '            image {',
    '              url',
    '              altText',
    '              width',
    '              height',
    '            }',
    '            price { amount currencyCode }',
    '            compareAtPrice { amount currencyCode }',
    '          }',
    '        }',
    '      }',
    '    }',
    '  }',
    '}',
  ].join('\n');

  var CART_QUERY = [
    'query SharedCartQuery($cartId: ID!) {',
    '  cart(id: $cartId) {',
    '    ...SharedCartFragment',
    '  }',
    '}',
    CART_FRAGMENT,
  ].join('\n');

  var CART_CREATE_MUTATION = [
    'mutation SharedCartCreate($lines: [CartLineInput!]) {',
    '  cartCreate(input: { lines: $lines }) {',
    '    cart {',
    '      ...SharedCartFragment',
    '    }',
    '    userErrors {',
    '      field',
    '      message',
    '    }',
    '  }',
    '}',
    CART_FRAGMENT,
  ].join('\n');

  var CART_LINES_ADD_MUTATION = [
    'mutation SharedCartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {',
    '  cartLinesAdd(cartId: $cartId, lines: $lines) {',
    '    cart {',
    '      ...SharedCartFragment',
    '    }',
    '    userErrors {',
    '      field',
    '      message',
    '    }',
    '  }',
    '}',
    CART_FRAGMENT,
  ].join('\n');

  var CART_LINES_UPDATE_MUTATION = [
    'mutation SharedCartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {',
    '  cartLinesUpdate(cartId: $cartId, lines: $lines) {',
    '    cart {',
    '      ...SharedCartFragment',
    '    }',
    '    userErrors {',
    '      field',
    '      message',
    '    }',
    '  }',
    '}',
    CART_FRAGMENT,
  ].join('\n');

  var CART_LINES_REMOVE_MUTATION = [
    'mutation SharedCartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {',
    '  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {',
    '    cart {',
    '      ...SharedCartFragment',
    '    }',
    '    userErrors {',
    '      field',
    '      message',
    '    }',
    '  }',
    '}',
    CART_FRAGMENT,
  ].join('\n');

  var CART_DISCOUNT_CODES_UPDATE_MUTATION = [
    'mutation SharedCartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {',
    '  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {',
    '    cart {',
    '      ...SharedCartFragment',
    '    }',
    '    userErrors {',
    '      field',
    '      message',
    '    }',
    '  }',
    '}',
    CART_FRAGMENT,
  ].join('\n');

  function getCartIdFromCookie() {
    return getCookie(CART_COOKIE_NAME);
  }

  function persistCartId(id) {
    if (!id) return;
    setCookie(CART_COOKIE_NAME, id, { maxAge: CART_COOKIE_MAX_AGE });
  }

  function handleUserErrors(result) {
    var userErrors = result && result.userErrors;
    if (userErrors && userErrors.length) {
      var messages = userErrors.map(function (e) { return e.message; }).join(', ');
      var error = new Error(messages || 'Storefront cart error');
      error.userErrors = userErrors;
      throw error;
    }
  }

  function fetchCart(cartId) {
    var existingId = cartId || getCartIdFromCookie();
    if (!existingId) return Promise.resolve(null);

    return storefrontRequest(CART_QUERY, { cartId: existingId })
      .then(function (data) {
        if (!data || !data.cart) {
          deleteCookie(CART_COOKIE_NAME);
          return null;
        }
        persistCartId(data.cart.id);
        return data.cart;
      })
      .catch(function (error) {
        if (error && (error.status === 404 || (error.graphQLErrors && error.graphQLErrors.length))) {
          deleteCookie(CART_COOKIE_NAME);
          return null;
        }
        throw error;
      });
  }

  function createCart() {
    return storefrontRequest(CART_CREATE_MUTATION, { lines: [] }).then(function (data) {
      if (!data || !data.cartCreate) return null;
      handleUserErrors(data.cartCreate);
      var cart = data.cartCreate.cart || null;
      if (cart && cart.id) {
        persistCartId(cart.id);
      }
      return cart;
    });
  }

  function getOrCreateCart() {
    return fetchCart().then(function (cart) {
      if (cart) return cart;
      return createCart();
    });
  }

  function addLines(merchandiseId, quantity) {
    var qty = Number(quantity) || 1;
    if (qty < 1) qty = 1;

    return getOrCreateCart().then(function (cart) {
      if (!cart || !cart.id) throw new Error('Unable to create cart');
      return storefrontRequest(CART_LINES_ADD_MUTATION, {
        cartId: cart.id,
        lines: [{ merchandiseId: merchandiseId, quantity: qty }],
      }).then(function (data) {
        if (!data || !data.cartLinesAdd) return cart;
        handleUserErrors(data.cartLinesAdd);
        var updatedCart = data.cartLinesAdd.cart || cart;
        if (updatedCart && updatedCart.id) {
          persistCartId(updatedCart.id);
        }
        return updatedCart;
      });
    });
  }

  function updateLine(lineId, quantity) {
    var qty = Number(quantity) || 0;
    if (qty < 0) qty = 0;

    return getOrCreateCart().then(function (cart) {
      if (!cart || !cart.id) throw new Error('Unable to create cart');
      if (qty === 0) {
        return removeLine(lineId);
      }
      return storefrontRequest(CART_LINES_UPDATE_MUTATION, {
        cartId: cart.id,
        lines: [{ id: lineId, quantity: qty }],
      }).then(function (data) {
        if (!data || !data.cartLinesUpdate) return cart;
        handleUserErrors(data.cartLinesUpdate);
        var updatedCart = data.cartLinesUpdate.cart || cart;
        if (updatedCart && updatedCart.id) {
          persistCartId(updatedCart.id);
        }
        return updatedCart;
      });
    });
  }

  function removeLine(lineId) {
    return getOrCreateCart().then(function (cart) {
      if (!cart || !cart.id) throw new Error('Unable to create cart');
      return storefrontRequest(CART_LINES_REMOVE_MUTATION, {
        cartId: cart.id,
        lineIds: [lineId],
      }).then(function (data) {
        if (!data || !data.cartLinesRemove) return cart;
        handleUserErrors(data.cartLinesRemove);
        var updatedCart = data.cartLinesRemove.cart || cart;
        if (updatedCart && updatedCart.id) {
          persistCartId(updatedCart.id);
        }
        return updatedCart;
      });
    });
  }

  function normalizeDiscountCodes(codes) {
    if (!Array.isArray(codes)) return [];
    return codes
      .map(function (code) {
        return String(code || '').trim();
      })
      .filter(Boolean);
  }

  function updateDiscountCodes(discountCodes) {
    var codes = normalizeDiscountCodes(discountCodes);

    return getOrCreateCart().then(function (cart) {
      if (!cart || !cart.id) throw new Error('Unable to create cart');
      return storefrontRequest(CART_DISCOUNT_CODES_UPDATE_MUTATION, {
        cartId: cart.id,
        discountCodes: codes,
      }).then(function (data) {
        if (!data || !data.cartDiscountCodesUpdate) return cart;
        handleUserErrors(data.cartDiscountCodesUpdate);
        var updatedCart = data.cartDiscountCodesUpdate.cart || cart;
        if (updatedCart && updatedCart.id) {
          persistCartId(updatedCart.id);
        }
        return updatedCart;
      });
    });
  }

  function extractVariantNumericId(variantGid) {
    if (typeof variantGid !== 'string') return null;
    var parts = variantGid.split('/');
    var last = parts[parts.length - 1];
    var id = parseInt(last, 10);
    return isNaN(id) ? null : id;
  }

  function toShopifyCartShape(cart) {
    if (!cart) return null;
    var lines = (cart.lines && cart.lines.edges) || [];
    var items = [];
    for (var i = 0; i < lines.length; i++) {
      var node = lines[i].node;
      var merchandise = node.merchandise || {};
      var variantIdNumeric = extractVariantNumericId(merchandise.id || '');
      items.push({
        quantity: node.quantity,
        variant_id: variantIdNumeric,
      });
    }

    var totalAmount = (cart.cost && cart.cost.totalAmount) || null;
    var itemCount = cart.totalQuantity || items.reduce(function (sum, item) { return sum + (item.quantity || 0); }, 0);

    return {
      id: cart.id,
      items: items,
      item_count: itemCount,
      total_price: totalAmount ? Math.round(parseFloat(totalAmount.amount || '0') * 100) : 0,
      currency: totalAmount ? totalAmount.currencyCode : null,
    };
  }

  // Sync Shopify session cart with Storefront cart for cross-sell and section rendering
  function syncSessionCart(cart) {
    var lines = (cart && cart.lines && cart.lines.edges) || [];

    // Build target quantities keyed by variant ID
    var targetQty = {};
    for (var i = 0; i < lines.length; i++) {
      var node = lines[i].node;
      var merchandise = node.merchandise || {};
      var variantId = extractVariantNumericId(merchandise.id || '');
      if (variantId) {
        targetQty[variantId] = (targetQty[variantId] || 0) + node.quantity;
      }
    }

    // Fetch current session cart, then compute a single atomic update
    fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    }).then(function(res) { return res.json(); })
      .then(function(sessionCart) {
        // Build updates object: zero-out items not in shared cart, set correct qty for shared cart items
        var updates = {};
        var sessionItems = (sessionCart && sessionCart.items) || [];
        for (var j = 0; j < sessionItems.length; j++) {
          var sid = sessionItems[j].variant_id;
          if (sid) updates[sid] = 0; // remove items not in shared cart
        }
        // Set shared cart quantities (overwrites zeros for items that should stay)
        for (var vid in targetQty) {
          if (targetQty.hasOwnProperty(vid)) {
            updates[vid] = targetQty[vid];
          }
        }

        // Skip update if session cart already matches
        var needsUpdate = false;
        for (var key in updates) {
          if (!updates.hasOwnProperty(key)) continue;
          var currentQty = 0;
          for (var k = 0; k < sessionItems.length; k++) {
            if (String(sessionItems[k].variant_id) === String(key)) {
              currentQty = sessionItems[k].quantity;
              break;
            }
          }
          if (currentQty !== updates[key]) {
            needsUpdate = true;
            break;
          }
        }
        // Also check if session cart has items not in updates
        if (!needsUpdate) {
          for (var m = 0; m < sessionItems.length; m++) {
            if (!updates.hasOwnProperty(sessionItems[m].variant_id)) {
              needsUpdate = true;
              break;
            }
          }
        }

        if (!needsUpdate) {
          fetchCrossSellFromServer();
          return;
        }

        // Single atomic update — no empty-cart window
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      }).then(function() {
        fetchCrossSellFromServer();
      }).catch(function(err) {
        console.error('Session cart sync failed', err);
      });
  }
  
  // Fetch cross-sell from server
  var crossSellFetchPending = false;
  function fetchCrossSellFromServer() {
    if (crossSellFetchPending) return;
    crossSellFetchPending = true;
    
    var scrollHint = document.querySelector('.cart-drawer__items');
    if (!scrollHint) {
      crossSellFetchPending = false;
      return;
    }
    
    var sectionId = document.querySelector('cart-items-component')?.dataset?.sectionId;
    if (!sectionId) {
      crossSellFetchPending = false;
      return;
    }
    
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    
    fetch(url.toString())
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newCrossSell = doc.querySelector('.cart-cross-sell');
        var existingCrossSell = document.querySelector('.cart-cross-sell');
        
        if (newCrossSell) {
          if (existingCrossSell) {
            existingCrossSell.replaceWith(newCrossSell);
          } else {
            // Insert after cart items table
            var cartTable = scrollHint.querySelector('.cart-items__table');
            if (cartTable) {
              cartTable.insertAdjacentElement('afterend', newCrossSell);
            }
          }
        } else if (existingCrossSell) {
          // No cross-sell in response, remove existing
          existingCrossSell.remove();
        }
      })
      .catch(function(err) {
        console.error('Cross-sell fetch failed', err);
      })
      .finally(function() {
        crossSellFetchPending = false;
      });
  }

  function dispatchCartUpdate(cart, isInitialLoad) {
    if (typeof document === 'undefined') return;
    var themeCart = toShopifyCartShape(cart);
    var eventDetail = {
      resource: themeCart,
      sourceId: 'shared-cart',
      data: {
        source: 'shared-cart',
        isInitialLoad: isInitialLoad || false,
      },
    };
    var evt;
    try {
      evt = new CustomEvent('cart:update', { bubbles: true, detail: eventDetail });
    } catch (e) {
      // IE fallback (not really needed, but harmless)
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('cart:update', true, true, eventDetail);
    }
    document.dispatchEvent(evt);
  }

  function setupAddToCartInterception(sharedApi) {
    if (typeof document === 'undefined') return;

    var handler = function (event) {
      var target = event.target;
      if (!(target instanceof HTMLFormElement)) return;
      var action = target.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      // product-form-component handles its own AJAX submission — don't double-add.
      if (target.closest && target.closest('product-form-component')) return;

      if (!sharedApi) return;

      event.preventDefault();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var idInput = target.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) {
        try {
          target.submit();
        } catch (e) {}
        return;
      }

      var variantIdNumeric = idInput.value;
      var quantityInput = target.querySelector('input[name="quantity"]');
      var quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;
      if (!quantity || quantity < 1) quantity = 1;

      var formData = new FormData(target);
      formData.delete('return_to');
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/add.js failed: ' + res.status);
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          var evt = new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'shared-cart-ajax', data: { source: 'shared-cart-ajax' } },
          });
          document.dispatchEvent(evt);
        })
        .catch(function (err) {
          console.error('/cart/add.js failed', err);
        });
    };

    document.addEventListener('submit', handler, true);
  }

  if (typeof window === 'undefined') {
    return;
  }

  var SharedCart = {
    getOrCreateCart: getOrCreateCart,
    fetchCart: function () {
      return fetchCart();
    },
    addLines: function (merchandiseId, quantity) {
      return addLines(merchandiseId, quantity).then(function (cart) {
        try { dispatchCartUpdate(cart); } catch (e) { console.error('dispatchCartUpdate failed', e); }
        try { syncSessionCart(cart); } catch (e) { console.error('syncSessionCart failed', e); }
        return cart;
      });
    },
    updateLine: function (lineId, quantity) {
      return updateLine(lineId, quantity).then(function (cart) {
        dispatchCartUpdate(cart);
        syncSessionCart(cart);
        return cart;
      });
    },
    removeLine: function (lineId) {
      return removeLine(lineId).then(function (cart) {
        dispatchCartUpdate(cart);
        syncSessionCart(cart);
        return cart;
      });
    },
    updateDiscountCodes: function (discountCodes) {
      return updateDiscountCodes(discountCodes);
    },
  };

  window.SharedCart = SharedCart;

  function initializeSharedCart() {
    setupAddToCartInterception(SharedCart);

    // Hydrate UI (bubble, drawer, etc.) from existing Storefront cart on page load, if any.
    fetchCart()
      .then(function (cart) {
        if (cart) {
          dispatchCartUpdate(cart, true);
          // Sync session cart on page load to ensure cross-sell renders correctly
          syncSessionCart(cart);
        }
      })
      .catch(function (error) {
        console.error('Shared cart initial fetch failed', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSharedCart);
  } else {
    initializeSharedCart();
  }
})();
